import { render, staticRenderFns } from "./ScholarshipDashboard_old.vue?vue&type=template&id=6c00ea7a&scoped=true"
import script from "./ScholarshipDashboard_old.vue?vue&type=script&lang=js"
export * from "./ScholarshipDashboard_old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00ea7a",
  null
  
)

export default component.exports